<template>
  <section class="h-full overflow-y-overlay flex-1 flex flex-col no-wrap">
    <slot />
  </section>
</template>
